if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){
	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
	

	$(document).ready(function () {

		$('.sym-slides').slick({
			accessibility: false
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};
	$('.js-expand-cta').click(function (event) {
		event.preventDefault();
		if($(this).hasClass("open")) {
			$(this).html('Read More');
			$(this).removeClass('open');
		} else {
			$(this).html('Read Less');
			$(this).addClass('open');
		}
		$(".expand-copy").slideToggle();
	});

	/*MOBILE MENU NAV
		****************************************************************/

	//Open Navigation
	$('#menu-btn,.burger-js').click(function (event) {
		event.preventDefault();
		$('html').addClass('hide-overflow');
		$('.navigation').addClass('open');
		$('.navigation').stop().animate({ left: '0px' }, { duration: 300 });
		if ($('.navigation ul li a').hasClass('.item-open')) {
			$(".item-open").get(0).scrollIntoView(false);
		}
	});

	$('.close-menu').click(function (event) {
		event.preventDefault();
		$('html').removeClass('hide-overflow');
		$('.navigation').removeClass('open');
		$('.navigation').stop().animate({ left: '100%' }, { queue: false, duration: 300 });
	});


	// if( document.querySelectorAll('.privary-navigation__item') ) {
	// 	let navButtons = document.querySelectorAll('.privary-navigation__item');
	// 	navButtons
	// }

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		if (document.querySelector("#landing-intro") != null  ) {
			document.getElementById('header').classList.add('down');
		}
	}

	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}